<div class="error-wrapper">
  <section class="error-section">
    <div class="error-container">
      <div class="error-content">
        <img
          [src]="'/assets/illustrations/' + illustration"
          class="error-illustration"
          alt="Error illustration"
        />
        <div class="error-text">
          <h1 *ngIf="title" class="error-title">{{ title }}</h1>
          <p *ngIf="subtitle" class="error-subtitle">{{ subtitle }}</p>
        </div>
      </div>
      <div class="error-actions">
        <button
          *ngIf="hasPrimaryButton"
          type="button"
          ps-primary-button
          (click)="handlePrimaryAction()"
        >
          <span class="button-text primary-button-text">{{ primaryButtonText }}</span>
        </button>
        <button
          *ngIf="hasSecondaryButton"
          type="button"
          ps-secondary-button
          (click)="handleSecondaryAction()"
        >
          <span class="button-text secondary-button-text">{{ secondaryButtonText }}</span>
        </button>
      </div>
    </div>
  </section>
</div>
